import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { faCopy, faEye } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormValidator } from 'src/app/shared/validators/Validator';
import { SolicitationService } from '../../services/usuario/solicitation.service';
import { ModalSolicitacaoNegativaComponent } from 'src/app/shared/modals/modal-solicitacao-negativa/modal-solicitacao-negativa.component';
@Component({
  selector: 'app-minhas-solicitacoes',
  templateUrl: './minhas-solicitacoes.component.html',
  styleUrls: ['./minhas-solicitacoes.component.css']
})
export class MinhasSolicitacoesComponent {
  faCopy = faCopy;
  faEye = faEye;
  loading: boolean = true;
  today = new Date();
  beneficiaries!: any[];
  myRequests: any;
  myRequestsFilter: any;
  solicitationTypes!: any[];
  formGroup: FormGroup = new FormGroup({
    itemsPerPage: new FormControl(5),
    page: new FormControl(1),
    solicitationTypeId: new FormControl(null),
    ansProtocol: new FormControl(null),
    initialDate: new FormControl(null, []),
    finalDate: new FormControl(null, [this.formValidator.isValidDateToday]),
  }, this.formValidator.dateLessOrEqualThan('initialDate', 'finalDate', { 'finalDate': true }));
  constructor(private formValidator: FormValidator, private solicitationService: SolicitationService, private toast: ToastrService, private modalService: NgbModal) {
    this.getFilter();
    this.solicitationService.listSolicitationTypes().subscribe((res: any) => {
      this.solicitationTypes = res;
    });
  }
  getFilter() {
    this.solicitationService.listSolicitations({ ...this.formGroup.value, page: this.formGroup.value.page - 1 }).subscribe((res: any) => {
      this.myRequests = res;
      this.loading = false;
    });
  }
  copiarTexto(prop: any) {
    navigator.clipboard.writeText(prop);
    this.toast.success("Protocolo copiado!")
  }

  abrirNegativa(reason:any){
    const modalRef = this.modalService.open(ModalSolicitacaoNegativaComponent, { windowClass: 'carteirinha-modal-size', centered: true });
    modalRef.componentInstance.reason = reason;
  }

  detalhes(prop: any) {
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.formGroup.value.itemsPerPage = quantidade;
    this.formGroup.value.page = 1;
    this.getFilter();
  }
  onChangePagination(page: number) {
    if (this.formGroup.value.page != page) {
      this.formGroup.value.page = page;
      this.getFilter();
    }
  }
}
